/* NEWSED v1.52 | GET-only public Boost adapter. No Shopify settings/product writes.
 * Captured responses are used in offline tests only, never shipped in this theme.
 * Products/count/filtering/paging are server-owned. No page-local filtering.
 */
(function (global, factory) {
  'use strict';
  var core = factory();
  if (typeof module === 'object' && module.exports) module.exports = core;
  if (!global || !global.document) return;
  if (global.NewsedBoostCollection) { global.NewsedBoostCollection.init(document); return; }
  var instances = new Map();
  var money = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY', maximumFractionDigits: 0 });
  function el(tag, cls, text) {
    var node = document.createElement(tag); if (cls) node.className = cls;
    if (text !== undefined) node.textContent = String(text); return node;
  }
  function flag(node, name, value) { node.setAttribute(name, value === undefined ? '' : value); return node; }
  function fieldError(message) { var e = new Error(message); e.name = 'InputError'; return e; }
  function initRoot(root) {
    if (instances.has(root)) return;
    var cfg = { shop: root.dataset.shop, collection: root.dataset.collectionId, limit: root.hasAttribute('data-newsed-search-terms') ? 24 : 48,
      currency: root.dataset.currency || 'JPY', productRoot: root.dataset.productRoot || '/',
      defaultSort: root.dataset.defaultSort || 'created-descending', tags: [],
      search: root.hasAttribute('data-newsed-search-terms'), query: root.dataset.newsedSearchTerms };
    try { cfg.tags = JSON.parse(root.dataset.currentTags || '[]') || []; } catch (_) { cfg.tags = []; }
    var quickEntries=null,quickGroups=[];
    var curatedQuick=root.querySelector('[data-newsed-curated-quick]');
    if(curatedQuick && root.dataset.collectionUrl){
      quickGroups=Array.from(curatedQuick.querySelectorAll('[data-newsed-quick-group]')).map(function(group){
        return Array.from(group.querySelectorAll('[data-newsed-quick-tag]')).map(function(link){return {tag:link.dataset.newsedQuickTag,handle:link.dataset.newsedTagHandle};});
      });
      quickEntries=core.readQuickTags(global.location.href,root.dataset.collectionUrl,quickGroups.flat(),cfg.tags);
      cfg.tags=quickEntries.map(function(entry){return entry.tag;});
      cfg=core.quickCollectionConfig(cfg,quickEntries,Array.from(curatedQuick.querySelectorAll('[data-newsed-quick-collection]')).map(function(link){
        return {tag:link.dataset.newsedQuickTag,collection:link.dataset.newsedQuickCollection,scopeTag:link.dataset.newsedQuickScopeTag,scopeVendor:link.dataset.newsedQuickScopeVendor};
      }));
    }
    var form = root.querySelector('[data-newsed-filter-form]');
    var scroll = root.querySelector('[data-newsed-boost-filters]');
    var panel = root.querySelector('[data-newsed-filter-drawer]');
    var grid = root.querySelector('[data-newsed-boost-grid]');
    var notice = root.querySelector('[data-newsed-boost-status]');
    var message = root.querySelector('[data-newsed-boost-message]');
    var retry = root.querySelector('[data-newsed-boost-retry]');
    var clearError = root.querySelector('[data-newsed-boost-reset-error]');
    var diag = root.querySelector('[data-newsed-boost-diagnostic]');
    var diagText = root.querySelector('[data-newsed-boost-diagnostic-text]');
    var apply = form.querySelector('[type="submit"]');
    var feedback = form.querySelector('[data-newsed-price-error]');
    var state = null, options = [], total = 0, stopped = false, timer = 0;
    var mainRequest = null, countRequest = null, requestNo = 0, countNo = 0;
    var cleanups = [];
    function on(node, event, fn) { node.addEventListener(event, fn); cleanups.push(function () { node.removeEventListener(event, fn); }); }
    function ui() { return global.NewsedCollectionUI; }
    function setBusy(busy) {
      grid.setAttribute('aria-busy', String(busy));
      root.querySelectorAll('[data-newsed-filter-open],[data-newsed-filter-more-open]').forEach(function (button) { button.disabled = busy; });
      root.querySelector('[data-newsed-sort-open]').disabled = busy;
      apply.disabled = busy;
    }
    function feedbackMessage(text) { feedback.textContent = text || ''; feedback.hidden = !text; }
    function currentURL(next) { return core.urlForState(global.location.href, next); }
    function resetURL() {
      var next = { sort: state ? state.sort : cfg.defaultSort, page: 1, filters: {} };
      return root.dataset.collectionUrl ? core.tagNavigationURL(global.location.href, root.dataset.collectionUrl, next) : currentURL(next);
    }
    function navigate(url) {
      if (url.origin !== global.location.origin) throw new Error('同一ストア以外には移動できません。');
      if (ui()) ui().close(root);
      global.location.assign(url.href);
    }
    async function fetchData(next, tree, signal) {
      var url = core.requestURL(cfg, next, tree);
      var response, data;
      try {
        response = await fetch(url.href, { method: 'GET', credentials: 'omit', signal: signal });
        if (!response.ok) throw new Error('HTTP ' + response.status);
        data = await response.json(); core.validateResponse(data, next, cfg, tree);
        return data;
      } catch (err) {
        // Only public catalogue/request data, never full product payloads or customer data.
        err.newsedDiagnostic = core.diagnosticFor(url, next, data, response && response.status, err);
        throw err;
      }
    }
    function cancelCount() { countNo++; clearTimeout(timer); if (countRequest) countRequest.abort(); countRequest = null; }
    function fail(err) {
      root.dataset.boostState = 'error'; root.dataset.resultCount = '';
      root.querySelector('.newsed-collection-count-number').textContent = '—';
      grid.replaceChildren(); grid.hidden = true; grid.setAttribute('aria-busy', 'false');
      root.querySelector('[data-newsed-boost-pagination]').hidden = true;
      notice.hidden = false; retry.hidden = false; clearError.hidden = false;
      clearError.href = resetURL().href;
      message.textContent = err.name === 'InputError' ? err.message : '商品一覧を取得できませんでした。商品が0件という意味ではありません。';
      diag.hidden = false;
      diagText.textContent = 'NEWSED v1.52 / GET only\nsource: ' + (cfg.search ? 'search' : 'collection ' + cfg.collection) +
        '\nerror: ' + (err.name === 'AbortError' ? '12秒以内に応答なし' : err.message) +
        '\nchecked: ' + new Date().toISOString() +
        (err.newsedDiagnostic ? '\ndetails: ' + JSON.stringify(err.newsedDiagnostic, null, 2) : '');
      root.newsedBoostLastError = err.newsedDiagnostic || { error: err.message };
      setBusy(true); grid.setAttribute('aria-busy','false');
    }
    function imageURL(src, width) {
      try { var url = new URL(src); if (url.protocol !== 'https:' || url.hostname !== 'cdn.shopify.com') return null;
        url.searchParams.set('width', String(width)); return url.href;
      } catch (_) { return null; }
    }
    function productCard(p, index) {
      var card = el('div', 'newsed-product-card newsed-card-v124');
      card.setAttribute('aria-label', p.title);
      card.dataset.productId = String(p.id);
      var pricing = core.cardPricing(p);
      var target = new URL(cfg.productRoot.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(p.handle), global.location.origin);
      if (pricing.variant && /^\d+$/.test(String(pricing.variant.id))) target.searchParams.set('variant', String(pricing.variant.id));
      var productHref = core.productURL(global.location.href, target.href).href;
      var media = el('div','newsed-pimg');
      var mediaLink=el('a','newsed-card-media-link');mediaLink.href=productHref;mediaLink.setAttribute('aria-label',p.title);media.appendChild(mediaLink);
      var infos = Array.isArray(p.images_info) ? p.images_info.slice().sort(function(a,b){return a.position-b.position;}) : [];
      var info = infos[0]; var src = info && info.src || (p.images && p.images['1']);
      var safe = imageURL(src,900);
      if (safe) {
        var img = el('img'); img.alt = info && info.alt || p.title;
        if (info && Number(info.width) > 0 && Number(info.height) > 0) {
          img.classList.toggle('newsed-card-image--portrait', Number(info.width) < Number(info.height));
        } else {
          img.addEventListener('load', function(){
            img.classList.toggle('newsed-card-image--portrait', img.naturalWidth > 0 && img.naturalWidth < img.naturalHeight);
          }, {once:true});
        }
        img.loading = index < 4 ? 'eager' : 'lazy'; img.decoding = 'async';
        img.sizes = '(max-width:760px) 50vw, 25vw';
        img.srcset = [360,540,720,900].map(function(w){return imageURL(src,w)+' '+w+'w';}).join(', ');
        if (info && info.width && info.height) { img.width = info.width; img.height = info.height; }
        img.addEventListener('error', function(){ img.remove(); mediaLink.prepend(el('span','newsed-boost-image-empty','画像を読み込めません')); }, {once:true});
        img.src = safe;
        mediaLink.appendChild(img);
      } else { mediaLink.appendChild(el('span','newsed-boost-image-empty','画像準備中')); }
      if (pricing.onSale) {
        var discountLabel = pricing.percent > 0 ? (root.dataset.discountLabel || '__PERCENT__% OFF').replace('__PERCENT__', String(pricing.percent)) : (root.dataset.saleLabel || 'SALE');
        media.appendChild(el('span','newsed-tag newsed-tag-sale',discountLabel));
      } else if ((p.tags || []).some(function(t){return String(t).toLowerCase()==='new';})) media.appendChild(el('span','newsed-tag','NEW'));
      // v1.31: native app control, outside the product link.
      var variant=pricing.variant;
      if(variant&&variant.id){
        var control=el('span','newsed-heart newsed-wishlist-control');control.setAttribute('data-newsed-wishlist-control','');control.dataset.wishlistState='loading';
        var svg=document.createElementNS('http://www.w3.org/2000/svg','svg');svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('aria-hidden','true');svg.setAttribute('focusable','false');
        var path=document.createElementNS('http://www.w3.org/2000/svg','path');path.setAttribute('d','M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z');svg.appendChild(path);control.appendChild(svg);
        var native=el('span','smartwishlist');native.setAttribute('data-product',String(p.id));native.setAttribute('data-variant',String(variant.id));native.setAttribute('data-newsed-wishlist-native','');control.appendChild(native);media.appendChild(control);
      }
      var view = core.cardPresentation(p);
      var meta = el('a','newsed-pmeta newsed-card-info-link');meta.href=productHref;
      var brand = el('div','newsed-brand',p.vendor || ''); brand.title = p.vendor || ''; meta.appendChild(brand);
      var title = el('div','newsed-pname',view.title); title.title = p.title; meta.appendChild(title);
      var row = el('div','newsed-prow');
      var taxLabel = root.dataset.taxLabel || '';
      if (pricing.onSale) {
        var prices = el('span','newsed-sale-price');
        prices.appendChild(el('s','newsed-compare-price',money.format(pricing.compareAt)+taxLabel));
        prices.appendChild(el('span','newsed-price newsed-price--sale',money.format(pricing.price)+taxLabel));
        row.appendChild(prices);
      } else row.appendChild(el('span','newsed-price',money.format(pricing.price)+taxLabel));
      if(view.rank) row.appendChild(el('span','newsed-rank-badge',view.rank+(root.dataset.rankLabel || 'ランク')));
      meta.appendChild(row); card.append(media,meta); return card;
    }
    async function hydrateRanks(products, seq, signal) {
      // Boost currently returns sort_key only. Read the same public metafield
      // used by Liquid cards in bounded batches; never infer condition from tags.
      var missing=products.filter(function(p){return !core.cardPresentation(p).rank;});
      if(!missing.length)return;
      var ctrl=new AbortController(),timeout=setTimeout(function(){ctrl.abort();},8000);
      function abort(){ctrl.abort();}
      signal.addEventListener('abort',abort,{once:true});
      root.dataset.rankState='loading';
      try {
        var batches=[];for(var i=0;i<missing.length;i+=20)batches.push(missing.slice(i,i+20));
        await Promise.all(batches.map(async function(batch){
          var url=core.rankURL(global.location.href,cfg.productRoot,batch.map(function(p){return p.handle;}));
          var response=await fetch(url.href,{method:'GET',credentials:'same-origin',signal:ctrl.signal});
          if(!response.ok)throw new Error('Rank metadata unavailable');
          var data=await response.json();
          if(!Array.isArray(data.products))throw new Error('Rank metadata unavailable');
          if(stopped || seq!==requestNo || signal.aborted)return;
          batch.forEach(function(p){
            var item=data.products.find(function(x){return x.handle===p.handle && String(x.id)===String(p.id);});
            if(!item || !/^(N|S|A|AB|BA|B|BC|C|J)$/.test(item.rank))return;
            var card=Array.from(grid.children).find(function(node){return node.dataset.productId===String(p.id);});
            if(card && !card.querySelector('.newsed-rank-badge'))card.querySelector('.newsed-prow').appendChild(el('span','newsed-rank-badge',item.rank+(root.dataset.rankLabel || 'ランク')));
          });
        }));
        if(!stopped && seq===requestNo)root.dataset.rankState='ready';
      }catch(_){if(!stopped && seq===requestNo)root.dataset.rankState='unavailable';}
      finally{clearTimeout(timeout);signal.removeEventListener('abort',abort);}
    }
    function priceValues(option) {
      var values = state.filters[option.filterOptionId];
      var range = values && values.length ? core.readRange(values[0]) : {min:'',max:''};
      if (root.querySelector('[data-newsed-price-quick]') && range.max === '1000000000000') range.max = '';
      return range;
    }
    function renderFilters() {
      // Destroy/recreate UI listeners before replacing controls; retain the exact v1.20 panels.
      if (ui()) ui().destroy(root);
      scroll.replaceChildren(el('p','newsed-boost-stock-note','販売中の商品のみ表示しています。'));
      options.forEach(function(o,index){
        if (o.filterType === 'stock') return;
        var values = state.filters[o.filterOptionId] || [];
        if (o.filterType !== 'price' && Array.isArray(o.values) && !o.values.length && !values.length) return;
        var detail = el('details','newsed-filter-group'); detail.open = index < 3 || values.length > 0;
        detail.dataset.boostFilterId = o.filterOptionId;
        var summary = el('summary'); summary.append(el('span','',o.label),el('span','newsed-filter-chevron','＋')); detail.appendChild(summary);
        var body = el('div','newsed-filter-group-body'); detail.appendChild(body);
        if (o.filterType === 'price') {
          var presets = flag(el('div','newsed-price-presets'),'role','group'); presets.setAttribute('aria-label','予算の上限を選ぶ');
          [10000,30000,50000,100000].forEach(function(n){var b=el('button','',money.format(n)+'以下');b.type='button';b.dataset.priceMax=String(n);b.setAttribute('aria-pressed','false');presets.appendChild(b);});
          var range = priceValues(o); var inputs = el('div','newsed-price-inputs');
          ['min','max'].forEach(function(side){
            if(side==='max')inputs.appendChild(el('span','newsed-price-separator','—'));
            var label=el('label');label.appendChild(el('span','',side==='min'?'下限':'上限'));
            var inner=el('div');inner.appendChild(el('i','','¥'));var input=el('input');input.inputMode='numeric';
            input.value=range[side];input.placeholder=side==='min'?'0':(o.values && Number.isFinite(o.values.max)?String(o.values.max):'指定なし');
            input.setAttribute('data-price-'+side+'-input','');inner.appendChild(input);label.appendChild(inner);inputs.appendChild(label);
          });
          body.append(presets,inputs);
        } else if (Array.isArray(o.values)) {
          // Category and colour are short lists for direct selection; brand search remains available.
          var directSelection = o.filterOptionId === 'pf_pt_kategori' || o.filterOptionId === 'pf_t_se' || core.isSizeFilter(o);
          if(o.values.length>10 && !directSelection){var search=el('label','newsed-filter-search-wrap');search.appendChild(el('span','visually-hidden',o.label+'を検索'));
            var input=el('input');input.type='search';input.placeholder=o.label+'を検索';input.setAttribute('data-newsed-filter-search','');search.appendChild(input);body.appendChild(search);}
          var wrap=flag(el('div','newsed-filter-options'),'data-newsed-filter-options');
          var list=o.values.slice();values.forEach(function(v){if(!list.some(function(x){return String(x.key)===v;}))list.push({key:v,label:v});});
          if (core.isSizeFilter(o)) list = core.sizeValues(list);
          var limitedBrands = o.filterType === 'vendor' && list.length > 12;
          if (limitedBrands) {
            list.sort(function(a,b){return (Number(b.doc_count)||0)-(Number(a.doc_count)||0);});
            detail.setAttribute('data-newsed-filter-limit','12');
            detail.setAttribute('data-newsed-filter-expanded','false');
            wrap.id = 'NewsedBrandOptions-' + root.dataset.sectionId + '-' + o.filterOptionId;
          }
          list.forEach(function(v){
            var key=String(v.key),label=String(v.label || v.key),selected=values.indexOf(key)!==-1;
            var row=flag(el('label','newsed-filter-option'),'data-filter-option');row.dataset.filterText=label.toLowerCase();
            var box=el('input');box.type='checkbox';box.name=o.filterOptionId;box.value=key;box.checked=selected;
            if(v.doc_count===0 && !selected){box.disabled=true;row.classList.add('is-disabled');}
            row.append(box,el('span','newsed-filter-box'),el('span','newsed-filter-option-label',label),el('span','newsed-filter-option-count',Number.isInteger(v.doc_count)?v.doc_count:'—'));
            wrap.appendChild(row);
          });body.appendChild(wrap);
          if (limitedBrands) {
            var more = flag(el('button','newsed-filter-more','すべて表示（'+list.length+'）'),'data-newsed-filter-more');
            more.type='button';more.setAttribute('aria-expanded','false');more.setAttribute('aria-controls',wrap.id);
            body.appendChild(more);
            var empty = flag(el('p','newsed-filter-search-empty','検索に一致するブランドがありません。'),'data-newsed-filter-search-empty');
            empty.hidden=true;empty.setAttribute('role','status');body.appendChild(empty);
          }
        }
        scroll.appendChild(detail);
      });
      if (ui()) ui().init(root);
    }
    function renderApplied() {
      var area=root.querySelector('[data-newsed-boost-applied]');area.replaceChildren();var n=0;
      if(quickEntries){
        quickEntries.forEach(function(entry){
          n++;var next=core.clone(state);next.page=1;
          var chip=el('a','newsed-applied-chip',entry.tag+' ×');
          chip.href=core.quickTagsURL(global.location.href,root.dataset.collectionUrl,quickEntries.filter(function(e){return e.tag!==entry.tag;}),next).href;area.appendChild(chip);
        });
      }else root.querySelectorAll('[data-newsed-current-tag-links] a').forEach(function(link){
        n++;var next=core.clone(state);next.page=1;
        var chip=el('a','newsed-applied-chip',link.textContent+' ×');
        chip.href=core.tagNavigationURL(global.location.href,link.href,next).href;area.appendChild(chip);
      });
      options.forEach(function(o){
        if(o.filterType==='stock')return;
        (state.filters[o.filterOptionId] || []).forEach(function(v){
          n++;var next=core.removeValue(state,o.filterOptionId,v);var label=v;
          if(o.filterType==='price'){
            var r=core.readRange(v);label=money.format(Number(r.min))+' – '+money.format(Number(r.max));
            var priceShortcut=Array.from(root.querySelectorAll('[data-newsed-quick-price]')).find(function(link){return link.dataset.newsedQuickPrice===v;});
            if(priceShortcut)label=priceShortcut.textContent.trim();
          }
          else {var match=o.values.find(function(x){return String(x.key)===v;});if(match)label=match.label||match.key;if(core.isSizeFilter(o))label=o.label+'：'+core.sizeLabel(v);}
          var chip=el('a','newsed-applied-chip',label+' ×');chip.href=currentURL(next).href;area.appendChild(chip);
        });
      });
      if(n){var reset=el('a','newsed-applied-clear','条件を解除');reset.href=resetURL().href;area.appendChild(reset);}
      var count=root.querySelector('[data-newsed-boost-filter-count]');count.textContent=String(n);count.hidden=!n;
      root.querySelectorAll('[data-newsed-reset]').forEach(function(a){a.href=resetURL().href;});
      root.querySelectorAll('[data-newsed-sort-value]').forEach(function(a){
        var s=core.clone(state);s.sort=a.dataset.newsedSortValue;s.page=1;a.href=currentURL(s).href;
        a.classList.toggle('is-current',state.sort===s.sort);
      });
      var quick=root.querySelector('[data-newsed-boost-quick]');
      if(!quick)return;
      var priceQuick=quick.querySelector('[data-newsed-price-quick]');
      if(priceQuick){
        var priceOption=options.find(function(o){return o.filterType==='price';});
        priceQuick.hidden=!priceOption;
        if(priceOption)priceQuick.querySelectorAll('[data-newsed-quick-price]').forEach(function(link){
          var value=link.dataset.newsedQuickPrice;
          var selected=state.filters[priceOption.filterOptionId] || [];
          var active=selected.length===1 && selected[0]===value;
          var next=core.clone(state);next.page=1;
          if(active)delete next.filters[priceOption.filterOptionId];
          else next.filters[priceOption.filterOptionId]=[value];
          link.href=currentURL(next).href;
          link.classList.toggle('is-active',active);
          if(active)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');
          link.removeAttribute('aria-disabled');
        });
      }
      if(quick.hasAttribute('data-newsed-curated-quick')){
        quick.querySelectorAll('[data-newsed-quick-tag]').forEach(function(link){
          var next=core.clone(state);next.page=1;
          var groupNode=link.closest('[data-newsed-quick-group]');
          var exclusiveType=groupNode && groupNode.dataset.newsedExclusiveFilterType;
          if(exclusiveType)options.filter(function(o){return o.filterType===exclusiveType;}).forEach(function(o){delete next.filters[o.filterOptionId];});
          var group=quickGroups.find(function(values){return values.some(function(v){return v.tag===link.dataset.newsedQuickTag;});});
          var active=quickEntries.some(function(entry){return entry.tag===link.dataset.newsedQuickTag;});
          link.href=core.quickTagsURL(global.location.href,root.dataset.collectionUrl,core.selectQuickTag(quickEntries,group,link.dataset.newsedQuickTag),next).href;
          link.classList.toggle('is-active',active);
          if(active)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');
        });
        quick.querySelectorAll('[data-newsed-quick-filter-type]').forEach(function(link){
          var option=options.find(function(o){return o.filterType===link.dataset.newsedQuickFilterType;});
          if(!option){link.removeAttribute('href');link.setAttribute('aria-disabled','true');return;}
          var values=link.dataset.newsedQuickFilterValues?JSON.parse(link.dataset.newsedQuickFilterValues):[link.dataset.newsedQuickFilterValue];
          var selected=state.filters[option.filterOptionId]||[];
          var active=selected.length===values.length && values.every(function(value){return selected.includes(value);});
          var next=core.clone(state);next.page=1;
          if(active)delete next.filters[option.filterOptionId];else next.filters[option.filterOptionId]=values;
          var groupNode=link.closest('[data-newsed-quick-group]');
          var groupTags=groupNode?Array.from(groupNode.querySelectorAll('[data-newsed-quick-tag]')).map(function(a){return a.dataset.newsedQuickTag;}):[];
          var entries=(quickEntries||[]).filter(function(entry){return !groupTags.includes(entry.tag);});
          link.href=core.quickTagsURL(global.location.href,root.dataset.collectionUrl,entries,next).href;
          link.classList.toggle('is-active',active);
          if(active)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');
          link.removeAttribute('aria-disabled');
        });
        return;
      }
      quick.replaceChildren();quick.classList.add('newsed-collection-quick--grouped');var added=0;
      options.forEach(function(o){
        if(!/(カテゴリー|category|アイテム|item|モデル|model|シリーズ|series|素材|material)/i.test(o.label)||!Array.isArray(o.values))return;
        var group=flag(el('div','newsed-quick-group'),'role','group');group.setAttribute('aria-label',o.label);
        group.appendChild(flag(el('span','newsed-quick-group-label',o.label),'aria-hidden','true'));
        var choices=el('div','newsed-quick-group-options');group.appendChild(choices);
        o.values.forEach(function(v){if(added>=7 || !(v.doc_count>0))return;added++;
          var s=core.clone(state);s.page=1;var key=String(v.key),list=s.filters[o.filterOptionId]||[];var active=list.length===1&&list[0]===key;
          if(active)delete s.filters[o.filterOptionId];else s.filters[o.filterOptionId]=[key];
          var a=el('a','newsed-quick-chip'+(active?' is-active':''),v.label||key);a.href=currentURL(s).href;if(active)a.setAttribute('aria-current','true');choices.appendChild(a);
        });
        if(choices.children.length)quick.appendChild(group);
      });
    }
    function renderPages() {
      var nav=root.querySelector('[data-newsed-boost-pagination]');nav.replaceChildren();
      var pages=Math.ceil(total/cfg.limit);nav.hidden=pages<=1;
      if(pages<=1)return;
      function link(p,text,cls){var s=core.clone(state);s.page=p;var a=el('a',cls,text);a.href=currentURL(s).href;return a;}
      nav.appendChild(state.page>1?link(state.page-1,'←','newsed-page-arrow'):el('span','newsed-page-arrow is-disabled','←'));
      var middle=el('div','newsed-page-numbers');var numbers=new Set([1,pages]);
      for(var n=Math.max(1,state.page-1);n<=Math.min(pages,state.page+1);n++)numbers.add(n);
      var prev=0;Array.from(numbers).sort(function(a,b){return a-b;}).forEach(function(p){
        if(prev && p-prev>1)middle.appendChild(el('span','','…'));
        if(p===state.page)middle.appendChild(flag(el('span','is-current',p),'aria-current','page'));
        else middle.appendChild(link(p,String(p),''));prev=p;
      });nav.appendChild(middle);
      nav.appendChild(state.page<pages?link(state.page+1,'→','newsed-page-arrow'):el('span','newsed-page-arrow is-disabled','→'));
    }
    async function load() {
      var seq=++requestNo;cancelCount();if(mainRequest)mainRequest.abort();mainRequest=new AbortController();
      var ctrl=mainRequest,timeout=setTimeout(function(){ctrl.abort();},12000);
      root.dataset.boostState='loading';setBusy(true);notice.hidden=false;retry.hidden=true;clearError.hidden=true;diag.hidden=true;
      message.textContent='販売中の商品を読み込んでいます。';grid.hidden=!grid.querySelector('.newsed-card-skeleton-v155');root.querySelector('[data-newsed-boost-pagination]').hidden=true;
      try{
        state=core.readState(global.location.href,cfg.defaultSort);
        var canonicalState=core.normalizeArrivalsVendors(state,cfg.requiredCollection || cfg.collection);
        if(JSON.stringify(canonicalState)!==JSON.stringify(state)){global.location.replace(currentURL(canonicalState).href);return;}
        var sortLabel=root.querySelector('[data-newsed-current-sort]');
        if(sortLabel){
          var sortLabels=JSON.parse(sortLabel.dataset.sortLabels);
          if(sortLabels[state.sort])sortLabel.textContent=sortLabels[state.sort];
        }
        var normalizedEntries=quickEntries&&core.normalizeQuickTags(quickEntries,quickGroups);
        if(normalizedEntries && normalizedEntries.length!==quickEntries.length){
          global.location.replace(core.quickTagsURL(global.location.href,root.dataset.collectionUrl,normalizedEntries,state).href);
          return;
        }
        var data=await fetchData(state,true,ctrl.signal);
        if(stopped || seq!==requestNo)return;
        options=core.filterOptions(data.filter.options,cfg);
        total=data.total_product;
        if(total>0 && (state.page-1)*cfg.limit>=total){state.page=1;navigate(currentURL(state));return;}
        root.dataset.resultCount=String(total);root.dataset.boostState='ready';
        root.querySelector('.newsed-collection-count-number').textContent=total.toLocaleString('ja-JP');
        grid.replaceChildren();data.products.forEach(function(p,i){grid.appendChild(productCard(p,i));});grid.hidden=false;
        hydrateRanks(data.products,seq,ctrl.signal);
        document.dispatchEvent(new CustomEvent('newsed:products-rendered'));
        renderFilters();renderApplied();renderPages();setBusy(false);feedbackMessage('');
        apply.textContent=total.toLocaleString('ja-JP')+'点の商品を見る';notice.hidden=total!==0;
        if(total===0){message.textContent='条件に合う商品がありません。';clearError.hidden=false;clearError.href=resetURL().href;}
        // Diagnostic summary is not injected into storefront UI on success.
        root.newsedBoostDiagnostic={version:'1.52',total:total,received:data.products.length,currency:data.meta.currency,
          filterIds:options.map(function(o){return o.filterOptionId;}),requestId:data.meta.rid,fromCache:data.from_cache};
      }catch(e){if(!stopped && seq===requestNo)fail(e);}
      finally{clearTimeout(timeout);}
    }
    function readForm() {
      var next=core.clone(state);next.page=1;next.filters={};
      options.forEach(function(o){
        if(o.filterType==='stock')return;
        if(o.filterType==='price'){
          var group=scroll.querySelector('[data-boost-filter-id="'+o.filterOptionId+'"]');
          var range=core.priceRange(group.querySelector('[data-price-min-input]').value,group.querySelector('[data-price-max-input]').value);
          if(!range.ok)throw fieldError(range.message);
          if(range.min!=='' || range.max!==''){
            var low=range.min || '0',high=range.max || String(Math.max(o.values && Number.isFinite(o.values.max)?o.values.max:1000000000000,Number(low)));
            var prior=state.filters[o.filterOptionId];
            if(range.max==='' && root.querySelector('[data-newsed-price-quick]') && prior && prior[0]==='50000:1000000000000' && low==='50000')high='1000000000000';
            next.filters[o.filterOptionId]=[low+':'+high];
          }
        }else{
          var chosen=Array.from(form.querySelectorAll('input[type="checkbox"]:checked')).filter(function(e){return e.name===o.filterOptionId;}).map(function(e){return e.value;});
          if(chosen.length)next.filters[o.filterOptionId]=chosen;
        }
      });return next;
    }
    function scheduleCount(event) {
      if(event && event.target.matches('[data-newsed-filter-search]'))return;
      if(root.dataset.boostState!=='ready')return;
      cancelCount();var seq=countNo;apply.textContent='件数を確認中…';apply.disabled=true;feedbackMessage('');
      timer=setTimeout(async function(){
        var ctrl=new AbortController();countRequest=ctrl;var timeout=setTimeout(function(){ctrl.abort();},12000);
        try{var next=readForm();core.validateSelection(next,options);var small=Object.assign({},cfg,{limit:1});
          var response=await fetch(core.requestURL(small,next,false).href,{method:'GET',credentials:'omit',signal:ctrl.signal});
          if(!response.ok)throw new Error('HTTP '+response.status);var data=await response.json();core.validateResponse(data,next,small,false);
          // Count requests omit the tree, so validate against the already loaded definitions.
          // Never label an unfiltered/error response as a filtered result count.
          core.validateProductFilters(data,next,options);
          if(stopped || seq!==countNo)return;apply.textContent=data.total_product.toLocaleString('ja-JP')+'点の商品を見る';apply.disabled=false;
        }catch(e){if(stopped || seq!==countNo)return;
          apply.textContent='商品を見る';apply.disabled=e.name==='InputError';
          feedbackMessage(e.name==='InputError'?e.message:'件数を確認できません。適用時に再確認します。');
        }finally{clearTimeout(timeout);}
      },400);
    }
    on(form,'input',scheduleCount);on(form,'change',scheduleCount);
    on(form,'click',function(e){if(e.target.closest('[data-price-max]'))scheduleCount();});
    on(form,'submit',function(e){e.preventDefault();if(root.dataset.boostState!=='ready')return;
      try{var next=readForm();core.validateSelection(next,options);navigate(currentURL(next));}catch(err){feedbackMessage(err.message);}
    });
    on(retry,'click',load);
    var observer=new MutationObserver(function(){if(panel.getAttribute('aria-hidden')==='true'){
      cancelCount();feedbackMessage('');if(root.dataset.boostState==='ready'){apply.disabled=false;apply.textContent=total.toLocaleString('ja-JP')+'点の商品を見る';}
    }});observer.observe(panel,{attributes:true,attributeFilter:['aria-hidden']});
    on(global,'pageshow',function(e){if(e.persisted)load();});
    instances.set(root,function(){stopped=true;cancelCount();if(mainRequest)mainRequest.abort();observer.disconnect();cleanups.forEach(function(f){f();});if(ui())ui().destroy(root);instances.delete(root);});
    load();
  }
  function init(container){if(container.matches && container.matches('[data-newsed-boost]'))initRoot(container);container.querySelectorAll('[data-newsed-boost]').forEach(initRoot);}
  global.NewsedBoostCollection={version:'1.52.0',init:init,core:core};
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
  document.addEventListener('shopify:section:unload',function(e){instances.forEach(function(destroy,root){if(e.target===root || e.target.contains(root))destroy();});});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);},{once:true});else init(document);
})(typeof window!=='undefined'?window:null,function(){
  'use strict';
  var sorts=['relevance','manual','best-selling','created-descending','price-ascending','price-descending'];
  var idPattern=/^pf_[a-zA-Z0-9_]+$/;
  function inputError(text){var e=new Error(text);e.name='InputError';return e;}
  function clone(state){return JSON.parse(JSON.stringify(state));}
  function quickCollectionConfig(cfg,entries,scopes){
    var selected=scopes.find(function(scope){return entries.some(function(entry){return entry.tag===scope.tag;});});
    if(!selected)return cfg;
    var next=clone(cfg);
    next.requiredCollection=cfg.collection;
    next.collection=selected.collection;
    next.tags=cfg.tags.filter(function(tag){return tag!==selected.tag;});
    if(selected.scopeTag && !next.tags.includes(selected.scopeTag))next.tags.push(selected.scopeTag);
    if(selected.scopeVendor)next.requiredVendor=selected.scopeVendor;
    return next;
  }
  function normalizeArrivalsVendors(state,collection){
    var next=clone(state);
    if(String(collection)==='514984575128' && next.filters.pf_v_burando){
      next.filters.pf_v_burando=Array.from(new Set(next.filters.pf_v_burando.map(function(value){return value==='Chrome Hearts'?'CHROME HEARTS':value;})));
    }
    return next;
  }
  function baseKey(key){return key.replace(/\[\]$/,'');}
  function readState(current,defaultSort){
    var url=new URL(current),sort=url.searchParams.get('sort_by') || url.searchParams.get('sort') || defaultSort || 'created-descending';
    if(!sorts.includes(sort))throw inputError('この並び順は接続確認中です。条件を解除して確認してください。');
    var page=url.searchParams.get('page') || '1';if(!/^\d+$/.test(page) || !Number.isSafeInteger(Number(page)) || Number(page)<1)throw inputError('ページ番号を確認してください。');
    var result={sort:sort,page:Number(page),filters:Object.create(null)};
    url.searchParams.forEach(function(value,key){
      if(key.startsWith('filter.') && key!=='filter.v.availability')throw inputError('以前の絞り込み条件が含まれています。条件を解除して選び直してください。');
      if(key==='filter.v.availability' && value!=='1')throw inputError('この一覧は販売中の商品が対象です。条件を解除して確認してください。');
      var id=baseKey(key);if(!id.startsWith('pf_'))return;
      if(!idPattern.test(id) || value.length>300 || !value)throw inputError('絞り込み条件の形式を確認してください。');
      if(!result.filters[id])result.filters[id]=[];if(!result.filters[id].includes(value))result.filters[id].push(value);
      if(result.filters[id].length>100)throw inputError('絞り込み条件が多すぎます。');
    });return result;
  }
  function yen(value){var text=String(value).normalize('NFKC').trim().replace(/^[¥￥]\s*/,'');if(!text)return {ok:true,value:''};
    if(!/^(?:\d+|\d{1,3}(?:,\d{3})+)$/.test(text))return {ok:false};var n=Number(text.replace(/,/g,''));
    return Number.isSafeInteger(n)&&n>=0&&n<=1000000000000?{ok:true,value:String(n)}:{ok:false};}
  function priceRange(min,max){var a=yen(min),b=yen(max);if(!a.ok || !b.ok)return {ok:false,message:'価格は0以上の整数の円で入力してください。'};
    if(a.value!=='' && b.value!=='' && Number(a.value)>Number(b.value))return {ok:false,message:'上限は下限以上にしてください。'};
    return {ok:true,min:a.value,max:b.value};}
  function readRange(value){var parts=String(value).split(':');if(parts.length!==2)throw inputError('価格条件の形式を確認してください。');
    var r=priceRange(parts[0],parts[1]);if(!r.ok || r.min==='' || r.max==='')throw inputError('価格条件の形式を確認してください。');return r;}
  function validateSelection(state,options){
    var index=new Map(options.map(function(o){return [o.filterOptionId,o];}));
    Object.keys(state.filters).forEach(function(id){var o=index.get(id);if(!o)throw inputError('この一覧で使えない条件があります。条件を解除して確認してください。');
      if(o.filterType==='stock' && state.filters[id].some(function(v){return v!=='in-stock';}))throw inputError('この一覧は販売中の商品が対象です。');
      if(isSizeFilter(o) && state.filters[id].some(function(v){return !sizeLabel(v);}))throw inputError('この一覧で使えない条件があります。条件を解除して確認してください。');
      if(o.filterType==='price'){if(state.filters[id].length!==1)throw inputError('価格条件が重複しています。');readRange(state.filters[id][0]);}
    });
  }
  function requestURL(cfg,state,tree){
    if(!/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/i.test(cfg.shop))throw inputError('商品一覧の接続先を確認できません。');
    if(cfg.search){
      if(typeof cfg.query!=='string' || !cfg.query.trim())throw inputError('検索語を入力してください。');
    }else if(!/^\d+$/.test(cfg.collection) || cfg.collection==='0')throw inputError('このコレクションの接続先を確認できません。');
    if(cfg.currency!=='JPY')throw inputError('この検証版は日本円の表示を確認するためのものです。');
    var u=new URL('https://services.mybcapps.com/bc-sf-filter/'+(cfg.search?'search':'filter'));
    var params={shop:cfg.shop,page:state.page,limit:cfg.limit,sort:state.sort,
      product_available:'true',price_mode:'min',build_filter_tree:String(tree),return_all_currency_fields:'false',event_type:cfg.search?'search':'filter'};
    if(cfg.search){params.q=cfg.query;params.search_filter_tree='true';}
    else params.collection_scope=cfg.collection;
    Object.entries(params).forEach(function(pair){u.searchParams.set(pair[0],String(pair[1]));});
    if(!Array.isArray(cfg.tags || []))throw inputError('タグ条件の形式を確認してください。');
    (cfg.tags || []).forEach(function(tag){u.searchParams.append('tag[]',String(tag));});
    var requestFilters=clone(state.filters);
    if(cfg.requiredVendor)requestFilters.pf_v_burando=[cfg.requiredVendor];
    Object.keys(requestFilters).sort().forEach(function(id){var values=requestFilters[id];
      if(!idPattern.test(id))throw inputError('不正なフィルターIDです。');
      if(!Array.isArray(values) || !values.length || values.some(function(v){return typeof v!=='string' || !v || v.length>300;}))throw inputError('絞り込み条件の形式を確認してください。');
      // Boost's storefront URL and API wire format differ. Its library keeps
      // selected values as arrays and serializes through jQuery.param, including
      // a single price range, e.g. pf_p_jia_ge[]=0:50000 (NOT two separate bounds).
      values.forEach(function(v){u.searchParams.append(id+'[]',v);});
    });
    if(Object.keys(requestFilters).length)u.searchParams.set('check_cache','false');
    return u;
  }
  function diagnosticFor(url,state,data,httpStatus,err){
    var info={request:String(url),filters:clone(state.filters),httpStatus:httpStatus || null};
    if(data && typeof data==='object'){
      info.currency=data.meta && data.meta.currency || null;
      info.requestId=data.meta && data.meta.rid || null;
      info.fromCache=typeof data.from_cache==='boolean'?data.from_cache:null;
      info.totalProduct=Number.isInteger(data.total_product)?data.total_product:null;
    }
    if(err && err.filterMismatch)info.mismatch=err.filterMismatch;
    return info;
  }
  function validateResponse(data,state,cfg,tree){
    if(!data || data.error || !Number.isInteger(data.total_product) || data.total_product<0 || !Array.isArray(data.products))throw new Error('Boostの応答形式を確認できません。');
    if(!data.meta || data.meta.currency!=='JPY')throw new Error('商品価格の通貨を確認できません。');
    if(data.products.length>cfg.limit)throw new Error('取得商品数が指定件数と一致しません。');
    var ids=new Set();data.products.forEach(function(p){
      if(!p || !p.id || !p.handle || typeof p.title!=='string' || p.available!==true || p.price_min===null || p.price_min==='' || p.price_min===undefined || !Number.isFinite(Number(p.price_min)) || Number(p.price_min)<0)throw new Error('商品情報・在庫条件を確認できません。');
      if((cfg.tags || []).some(function(tag){return !(p.tags || []).includes(tag);}))throw new Error('タグ条件と取得商品が一致しません。');
      if(ids.has(String(p.id)))throw new Error('商品が重複しています。');ids.add(String(p.id));
      if(!cfg.search && Array.isArray(p.collections) && !p.collections.some(function(c){return String(c.id)===cfg.collection;}))throw new Error('所属コレクションを確認できません。');
      if(cfg.requiredCollection && (!Array.isArray(p.collections) || !p.collections.some(function(c){return String(c.id)===cfg.requiredCollection;})))throw new Error('コレクションの条件と取得商品が一致しません。');
      if(cfg.requiredVendor && p.vendor!==cfg.requiredVendor)throw new Error('ブランド条件と取得商品が一致しません。');
    });
    var expected=Math.min(cfg.limit,Math.max(0,data.total_product-(state.page-1)*cfg.limit));
    if(data.products.length!==expected)throw new Error('件数と取得ページの整合を確認できません。');
    if(tree){if(!data.filter || !Array.isArray(data.filter.options))throw new Error('絞り込み項目を取得できません。');
      var options=data.filter.options.filter(function(o){return o.status==='active';});
      options.forEach(function(o){if(!idPattern.test(o.filterOptionId) || typeof o.label!=='string')throw new Error('絞り込み項目の形式が不正です。');
        if(o.filterType==='price'){if((!o.values || !Number.isFinite(o.values.min)||!Number.isFinite(o.values.max)) && data.total_product!==0)throw new Error('価格範囲を確認できません。');}
        else if(!Array.isArray(o.values))throw new Error('未対応の絞り込み項目形式です。');
      });options=filterOptions(options,cfg);validateSelection(state,options);validateProductFilters(data,state,options);
    }
    // Spot checks do not substitute for live cross-page and AND/OR acceptance tests.
    if(state.sort==='price-ascending' || state.sort==='price-descending'){
      var direction=state.sort==='price-ascending'?1:-1;
      for(var i=1;i<data.products.length;i++)if(direction*(Number(data.products[i].price_min)-Number(data.products[i-1].price_min))<0)throw new Error('価格の並び順を確認できません。');
    }
    return true;
  }
  function validateProductFilters(data,state,options){
    options.forEach(function(o){var selected=state.filters[o.filterOptionId]||[];if(!selected.length)return;
      data.products.forEach(function(p){
        if(o.filterType==='vendor' && !selected.includes(p.vendor))throw new Error('ブランド条件と取得商品が一致しません。');
        if(o.filterType==='tag' && (!o.prefix || isSizeFilter(o)) && !selected.some(function(v){return (p.tags||[]).includes(v);}))throw new Error('タグ条件と取得商品が一致しません。');
        if(o.filterType==='price' && (p.variants||[]).length<=1){var r=readRange(selected[0]);var price=Number(p.price_min);
          if(price<Number(r.min) || price>Number(r.max)){
            var error=new Error('価格条件と取得商品が一致しません。');
            error.filterMismatch={filterId:o.filterOptionId,requestedMin:Number(r.min),requestedMax:Number(r.max),
              productId:String(p.id),priceMin:price,priceMax:p.price_max,variantCount:(p.variants||[]).length};
            throw error;
          }}
      });
    });
  }
  function urlForState(current,state){
    var u=new URL(current);Array.from(u.searchParams.keys()).forEach(function(key){
      if(key.startsWith('pf_')||key.startsWith('filter.')||key==='sort'||key==='sort_by'||key==='page'||/^page_/.test(key)||key==='sections'||key==='section_id')u.searchParams.delete(key);
    });u.searchParams.set('sort_by',state.sort);if(state.page>1)u.searchParams.set('page',String(state.page));
    Object.keys(state.filters).sort().forEach(function(id){state.filters[id].forEach(function(v){u.searchParams.append(id,v);});});return u;
  }
  function tagNavigationURL(current,target,state){
    var url=urlForState(current,state),destination=new URL(target,url);
    if(destination.origin!==url.origin)throw new Error('外部コレクションURLです。');
    url.pathname=destination.pathname;url.hash='';url.searchParams.delete('page');
    return url;
  }
  function removeValue(state,id,value){var next=clone(state);next.page=1;next.filters[id]=(next.filters[id]||[]).filter(function(v){return v!==value;});if(!next.filters[id].length)delete next.filters[id];return next;}
  function readQuickTags(current,collectionURL,choices,currentTags){
    var currentURL=new URL(current),base=new URL(collectionURL,currentURL);
    var prefix=base.pathname.replace(/\/$/,'')+'/';
    if(!currentURL.pathname.startsWith(prefix))return [];
    return currentURL.pathname.slice(prefix.length).split('+').filter(Boolean).map(function(value){
      var handle=decodeURIComponent(value),choice=choices.find(function(c){return c.handle===handle;});
      var tag=choice?choice.tag:currentTags.find(function(t){return String(t).toLowerCase().replace(/\s+/g,'-')===handle;})||handle;
      return {tag:tag,handle:handle};
    });
  }
  function normalizeQuickTags(entries,groups){
    return entries.filter(function(entry,index){
      var group=groups.find(function(g){return g.some(function(v){return v.tag===entry.tag;});});
      return !group || !entries.slice(index+1).some(function(next){return group.some(function(v){return v.tag===next.tag;});});
    });
  }
  function selectQuickTag(entries,group,tag){
    var next=entries.filter(function(entry){return !group.some(function(v){return v.tag===entry.tag;});});
    if(!entries.some(function(entry){return entry.tag===tag;}))next.push(group.find(function(v){return v.tag===tag;}));
    return next;
  }
  function quickTagsURL(current,collectionURL,entries,state){
    var target=new URL(collectionURL,current);
    if(entries.length)target.pathname=target.pathname.replace(/\/$/,'')+'/'+entries.map(function(entry){return encodeURIComponent(entry.handle);}).join('+');
    return tagNavigationURL(current,target.href,state);
  }
  function productURL(current,target){var from=new URL(current),to=new URL(target,from);if(to.origin!==from.origin)throw new Error('外部商品URLです。');
    ['preview_theme_id','_fd','_sc','pb'].forEach(function(key){if(from.searchParams.has(key))to.searchParams.set(key,from.searchParams.get(key));});return to;}
  function metafield(p,namespace,key){var rows=Array.isArray(p.metafields)?p.metafields:[];
    var f=rows.find(function(x){return x.namespace===namespace && x.key===key;});return f && typeof f.value==='string'?f.value:'';}

  function rankURL(current,productRoot,handles){
    if(!handles.length || handles.length>20 || handles.some(function(h){return typeof h!=='string' || !h || h.length>255 || /[|/?#]/.test(h);}))throw new Error('Invalid product handles');
    var target=new URL(productRoot.replace(/\/?$/,'/')+'search',new URL(current).origin);
    target.searchParams.set('q',handles.join('|'));target.searchParams.set('type','product');target.searchParams.set('view','newsed-card-data');
    return productURL(current,target.href);
  }

  function isSizeFilter(o) {
    return o.filterType === 'tag' && (o.filterOptionId === 'pf_t_saizu' || o.prefix === 'サイズ:' || /^(?:サイズ|size)$/i.test(String(o.label || '').trim()));
  }
  var apparelSizes = ['XS','S','M','L','XL','XXL'];
  function sizeLabel(key) {
    if (typeof key !== 'string' || !key.startsWith('サイズ:')) return '';
    var label = key.slice('サイズ:'.length);
    return apparelSizes.includes(label) || (/^\d+(?:\.\d+)?cm$/.test(label) && Number(label.slice(0,-2)) > 0) ? label : '';
  }
  function sizeValues(values) {
    var seen = new Set();
    return values.filter(function(v){
      if (!sizeLabel(v.key) || seen.has(v.key)) return false;
      seen.add(v.key); return true;
    }).map(function(v){return Object.assign({},v,{label:sizeLabel(v.key)});}).sort(function(a,b){
      var ai=apparelSizes.indexOf(a.label), bi=apparelSizes.indexOf(b.label);
      if (ai !== -1 || bi !== -1) return (ai === -1 ? apparelSizes.length : ai) - (bi === -1 ? apparelSizes.length : bi);
      return Number(a.label.slice(0,-2)) - Number(b.label.slice(0,-2));
    });
  }
  function filterOptions(raw,cfg) {
    return raw.filter(function(o){return o.status==='active';}).map(function(o){
      if(cfg && cfg.requiredVendor && o.filterType==='vendor')return Object.assign({},o,{values:o.values.filter(function(v){return v.key===cfg.requiredVendor;})});
      return isSizeFilter(o) ? Object.assign({},o,{values:sizeValues(o.values).filter(function(v){return v.doc_count > 0;})}) : o;
    });
  }
  function cardPresentation(p) {
    function clean(value) {return String(value || '').replace(/\s+/g,' ').trim();}
    var rawTitle=clean(p.title), title=clean(metafield(p,'custom','model') || metafield(p,'custom','name') || rawTitle);
    // Strip only a verified leading brand plus a separator. Do not infer product names.
    var aliases={
      'PRADA':['プラダ'], 'BALENCIAGA':['バレンシアガ'], 'GUCCI':['グッチ'],
      'TOM WOOD':['トムウッド'], 'LOUIS VUITTON×SUPREME':['ルイヴィトン×シュプリーム']
    };
    var vendor=clean(p.vendor), prefixes=[vendor].concat(aliases[vendor.toUpperCase()] || []).filter(Boolean);
    for (var repeat=0;repeat<2;repeat++) {
      var match=prefixes.find(function(prefix){return title.toLowerCase().startsWith(prefix.toLowerCase()) && /^\s/.test(title.slice(prefix.length));});
      if(!match)break;
      var rest=title.slice(match.length).trim();if(!rest)break;title=rest;
    }
    // Retain uncertain information; two-line CSS clamp handles remaining length.
    title=title || rawTitle;
    var rawSize=metafield(p,'custom','_size').replace(/\r/g,'');
    var found=rawSize.match(/(?:^|\n)[ \t　]*表記サイズ[ \t　]*[:：][ \t　]*([^\n]*)/);
    var size=found?found[1].split(/(?:目安サイズ|肩幅|身幅|着丈|袖丈|アウトソール|ワイズ幅)\s*[:：]/)[0].trim():'';
    size=size.replace(/[―—–－-]+$/g,'').trim();
    if(size.length>35 || !/[0-9A-Za-z０-９Ａ-Ｚａ-ｚ]/.test(size) || /不明|記載なし|記載無し|なし|無し|未確認|程度|約\s*cm|^cm$|^N\/?A$/i.test(size))size='';
    var rank=clean(metafield(p,'custom','_condition_rank'));
    if(!['N','S','A','AB','BA','B','BC','C','J'].includes(rank))rank='';
    var facts=[];if(size)facts.push('表記 '+size);if(rank)facts.push('状態 '+rank);
    return {title:title,facts:facts.join(' ｜ '),size:size,rank:rank};
  }

  function cardPricing(p) {
    function amount(value) {
      if ((typeof value !== 'string' && typeof value !== 'number') || String(value).trim() === '') return null;
      var n = Number(value); return Number.isFinite(n) && n >= 0 ? n : null;
    }
    var variants = Array.isArray(p.variants) ? p.variants.filter(Boolean) : [];
    var variant = variants.find(function(v){return v.available === true;}) || variants[0];
    var price = variant ? amount(variant.price) : null;
    var compareAt = variant ? amount(variant.compare_at_price) : null;
    var onSale = price !== null && compareAt !== null && compareAt > 0 && compareAt > price;
    var priceMinor = Math.round(price * 100), compareMinor = Math.round(compareAt * 100);
    return {variant:variant, price:price === null ? Number(p.price_min) : price, compareAt:compareAt,
      onSale:onSale, percent:onSale ? Math.floor((compareMinor - priceMinor) * 100 / compareMinor) : 0};
  }

  return {readState:readState,requestURL:requestURL,diagnosticFor:diagnosticFor,validateResponse:validateResponse,validateSelection:validateSelection,
    quickCollectionConfig:quickCollectionConfig,normalizeArrivalsVendors:normalizeArrivalsVendors,urlForState:urlForState,tagNavigationURL:tagNavigationURL,readQuickTags:readQuickTags,normalizeQuickTags:normalizeQuickTags,selectQuickTag:selectQuickTag,quickTagsURL:quickTagsURL,validateProductFilters:validateProductFilters,productURL:productURL,rankURL:rankURL,priceRange:priceRange,readRange:readRange,clone:clone,removeValue:removeValue,metafield:metafield,isSizeFilter:isSizeFilter,sizeLabel:sizeLabel,sizeValues:sizeValues,filterOptions:filterOptions,cardPresentation:cardPresentation,cardPricing:cardPricing};
});
